export default `
mutation cancelQuote($quoteUid: String!) {
    cancelQuote(quoteUid: $quoteUid)
}
`;
